// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="-3539 -387 10 14"><path fill="#fff" d="M-3538.9-380.4a1.062 1.062 0 011.3-.5l2.6 1.3v-6.4a.945.945 0 011-1 .945.945 0 011 1v6.4l2.6-1.3a1.053 1.053 0 011.3.4 1.094 1.094 0 01-.4 1.3l-4 2a.551.551 0 01-.5.2c-.2 0-.3 0-.4-.1l-4-2a1.062 1.062 0 01-.5-1.3zm8.9 5.4h-8a1 1 0 000 2h8a1 1 0 000-2z"/></svg>
);

export default fn;
